import type { ProcessingProfile } from '../../../../../Model/Order/processingProfile.js'
import type { ReportSection, SectionId } from '../ReportSection.js'
import { cover } from './cover.js'
import { consensus, demultiplexing, merging, primerRemoval, qc, qualityFiltering, rawReads } from './preprocessing.js'
import { clustering, dereplication, preclusteringChimera, taxonomy } from './postprocessing.js'
import { perSample } from './perSample.js'

/** In print order. */
export const REPORT_SECTIONS: readonly ReportSection[] = [
  cover,
  qc,
  rawReads,
  demultiplexing,
  merging,
  primerRemoval,
  qualityFiltering,
  consensus,
  dereplication,
  preclusteringChimera,
  clustering,
  taxonomy,
  perSample
]

export const appliedSections = (profile: ProcessingProfile): readonly ReportSection[] => REPORT_SECTIONS.filter((s) => s.applies(profile))

export const appliedSectionIds = (profile: ProcessingProfile): SectionId[] => appliedSections(profile).map((s) => s.id)
